import styled from 'styled-components';

import { theme } from '../../../global';

export interface IModalContainerStylesProps {
  $isActive?: boolean;
}

export const ModalContainer = styled.div<IModalContainerStylesProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  visibility: ${({ $isActive }) => ($isActive ? 'visible' : 'hidden')};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $isActive }) =>
    $isActive ? theme.colors.modal_background : 'transparent'};
  transition: background-color 0.2s ease-out;
  transition-delay: revert;
  user-focus: none;

  @media (max-width: 768px) {
    align-items: flex-end;
    padding-bottom: 40px;
  }
`;

export const StyledModal = styled.div<IModalContainerStylesProps>`
  position: relative;
  width: 484px;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 4px 11px ${theme.colors.shadow_secondary};
  background-color: ${theme.colors.white};
  max-height: 70vh;
  overflow-y: scroll;
  transform: scale(${({ $isActive }) => ($isActive ? 1 : 0)});
  transition: transform 0.2s ease-out;

  /*Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media (max-width: 768px) {
    max-width: 97vw;
  }
`;

export const ModalCrossWrapper = styled.div`
  position: absolute;
  right: 28px;
  top: 28px;
  cursor: pointer;
`;

export const ModalTitle = styled.p`
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  text-transform: uppercase;
  text-align: center;
  color: ${theme.colors.font_dark};
  padding-bottom: 20px;
`;
